import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// ./~/rc-rate/es/index.js
// module id = 2583
// module chunks = 0